import { forwardRef } from "react";

import useNow from "@/hooks/useNow";
import { formatRelativeTime } from "@/shared/formatters";
import dayjs, { DateInput } from "@/utils/date";

type FormatRelativeTimeProps = {
  date: NonNullable<DateInput>;
  options?: Intl.RelativeTimeFormatOptions;
} & Omit<React.ComponentProps<"span">, "style">;

export const FormatRelativeTime = forwardRef<
  HTMLSpanElement,
  FormatRelativeTimeProps
>((props, ref) => {
  const { date, options, ...spanProps } = props;
  const diffInSeconds = dayjs(date).diff(dayjs(), "seconds");
  const updateInterval = getUpdateIntervalMillis(diffInSeconds);
  useNow(updateInterval);
  return (
    <span ref={ref} {...spanProps}>
      {formatRelativeTime(dayjs(date).toDate(), options)}
    </span>
  );
});

function getUpdateIntervalMillis(intervalInSeconds: number) {
  const absValue = Math.abs(intervalInSeconds);
  if (absValue <= 60) {
    return 10 * 1000; // 10 seconds
  } else if (absValue <= 10 * 60) {
    return 30 * 1000; // 30 seconds
  } else if (absValue <= 30 * 60) {
    return 60 * 1000; // 1 minute
  } else if (absValue <= 60 * 60) {
    return 10 * 60 * 1000; // 10 minutes
  } else if (absValue <= 60 * 60 * 24) {
    return 30 * 60 * 1000; // 30 minutes
  }
  return null;
}
